import {
    prop,
    required,
    maxLength,
    minLength,
    trim
} from "@rxweb/reactive-form-validators";

export enum ActGroupMessageType {
    Info = 1,
    Warning = 2,
    Error = 3
}

export class ActGroupMessageViewModel {
    @minLength({ value: 36 })
    @maxLength({ value: 36 })
    id: string;

    @prop()
    actGroupId: string;

    @required()
    @trim()
    message: string;

    @prop()
    active: boolean = true;

    @required()
    type: ActGroupMessageType;

    @prop()
    isBlockCommunicate: boolean = false;

    @prop()
    profileId: string;

    @prop()
    ownerId?: string | null;

    @prop()
    lastUserId?: string | null;

    @prop()
    dateCreated?: string | null;

    @prop()
    dateModified?: string | null;
}